export default "__VITE_ASSET__F_8W5R4h__"